<template>
  <div class="brand-vendor">
        <div v-if="brandOrVendor.id">
             <div class="title">{{xxZone}}</div>
            <div class="brandAreaTop">
                <div class="left">
                    <a :href="brandOrVendor.link" target="_blank" @click="LogoBp"><img :src="brandOrVendor.logo || $brandLogoDefaultImgUrl"></a>
                </div>
                <div class="right">
                    <strong>
                        <a :href="brandOrVendor.link" target="_blank" @click="titleBp">{{brandOrVendor.name}}</a>
                    </strong>
                    <div class="doc">
                        {{brandOrVendor.desc}}
                        <a v-if="brandOrVendor.desc_link" :href="brandOrVendor.desc_link" target="_blank" @click="moreBp">{{detailsOrBaike}}&gt;&gt;</a>
                    </div>
                </div>
            </div>
            <div class="brandAreali" v-for="(items,index) in brandOrVendor.items" :key="index">
                <p class="p1">
                    <a :href="items.link" target="_blank">{{items.name}}</a>
                </p>
                <p class="p2">
                    <a :href="item.link" target="_blank" :title="item.name" class="ml0" v-for="(item,index) in items.sg.filter((v,index)=>{return index < 5})" :key="index" @click="serialBp">{{item.name}}</a>
                    <a :href="items.al_sg_link" target="_blank" class="blue" v-if="items.sg.length >=5" @click="allSerialBp">全部车系 &gt;&gt;</a>
                </p>
            </div>
        </div>
        <div v-if="serailData.id">
            <div class="title">{{xxZone}}</div>
            <div v-if="serailData">
                <div class="cars-zone">
                    <div class="cars-left">
                        <a :href="serailData.link" target="_blank" @click='countAd(4472)'>
                            <img :src="serailData.logo || $carsDefaultImgUrl">
                        </a>    
                    </div>
                    <div class="cars-right">
                        <p class="p1"><a :href="serailData.link" target="_blank" @click='countAd(4473)'>{{serailData.name}}</a></p>
                        <p class="p2">官方价：<a :href="serailData.price_link" target="_blank" @click='countAd(4474)'>{{serailData.price}}</a></p>
                        <p class="p3">
                            <a :href="lab.link" target="_blank" v-for="(lab,index) in serailData.labels" :key="index" @click="serailListBp(lab)">{{lab.label}}</a>
                        </p>
                    </div>
                </div>
                    <div class="jjxx" v-if="serailData.models && serailData.models.length">
                        <p class="jjxxTit">{{serailData.name}}{{serailData.region_name}}市降价信息</p>
                        <p class="jjxxli" v-for="(item,index) in serailData.models" :key="index">
                            <a :href="item.link" target="_blank" class="a1" :title="item.name" @click="countAd(4479)">{{item.name}}</a>
                            <span class="del">{{item.price}}</span>
                            <span class="red"><a :href="item.link" target="_blank" @click="countAd(4480)">{{item.d_price}}</a></span>
                        </p>
                    </div>				
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BrandOrVendor',
    props: {
        serailRightData: {
            type: Object,
            default: () => ({})
        },
        brandOrVendorData: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            serailData: {},
            brandOrVendor: {},
        }
    },
    methods: {
        serailListBp(labs) {
            if(labs.label === '报价') {
                this.countAd(4475)
            }else if(labs.label === '图片') {
                this.countAd(4476)
            }else if(labs.label === '参配') {
                this.countAd(4477)
            }else if(labs.label === '论坛') {
                this.countAd(4478)
            }
        },
       
        LogoBp() { //品牌或者厂商logo埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4485)
            }else {
                this.countAd(4481) //厂商
            }
        },
        titleBp() { //名称
            if(this.$global.qType === 1) { //品牌
                this.countAd(4486)
            }else {
                this.countAd(4482) //厂商
            }
        },
        serialBp() { //车系埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4488)
            }else {
                this.countAd(4483) //厂商
            }
        },
        allSerialBp() { 
            if(this.$global.qType === 1) { //品牌
                this.countAd(4489)
            }else {
                this.countAd(4484) //厂商
            }
        },
        moreBp() { 
            if(this.$global.qType === 1) { //品牌
                this.countAd(4487)
            }else {
                this.countAd(4544) //厂商
            }
        },
        // ivyAdd() {
        //     this.$utils.getScript('//ivy.pconline.com.cn/adpuba/show?id=auto.ks.jgycb.&media=js&channel=inline&trace=1')
        // }
    },
    watch: {
        serailRightData(n){
            this.serailData = n
            // if(n.id) {
            //     this.ivyAdd()
            // }
        },
        brandOrVendorData(n) {
            this.brandOrVendor = n
        },
    },
    computed: {
        // 某某专区
        xxZone() {
            return this.$global.qType === 1 ? '品牌专区' :  this.$global.qType === 2 ? '厂商专区' : '车系专区'
        },
        // 详情/品牌百科
        detailsOrBaike() {
            return  this.$global.qType === 1 ? '品牌百科' : '详情'
        },
    },
};
</script>

<style lang="scss" scoped>
.brand-vendor {
    margin-bottom: 25px;
        .title {
            height: 27px;
            background: #f4f4f4;
            border-top: 1px solid #e0e0e0;
            line-height: 27px;
            color: #333333;
            font-weight: bold;
            padding-left: 10px;
        }
  .brandAreaTop {
	  display: flex;
	  justify-content: space-between;
	  margin-top: 15px;
	  padding-bottom: 15px;
	  border-bottom: 1px solid #e3e3e3e3;
	  .doc {
		  width: 245px;
	  }
	  img {
		border: 1px solid #cccccc;
		width: 48px;
		height: 48px;
	  }
	  .right {
		  strong {
			  a {
				color: #225599;
			  }
		  }
		  .doc {
			  a {
				  color: #225599;
			  }
		  }
	  }
  }
  .brandAreali {
	border-bottom: 1px dashed #e3e3e3;
	&:last-of-type {
		border-bottom: 1px dashed transparent;
	}
	.p1 {
		font-weight: bold;
		line-height: 24px;
		height: 24px;
		overflow: hidden;
		margin-top: 8px;	
		a {
			color: #333333;
			display: block;
			width: 76px;
			overflow: hidden;
			float: left;		
		}	
	}
	.p2 {
		overflow: hidden;
		line-height: 22px;
		display: flex;
		flex-wrap: wrap;
		width: 307px;
		padding-bottom: 5px;
		a {
			height: 22px;
			overflow: hidden;
			width: 99px;
			word-wrap: break-word;
			word-break: break-all;
			margin-left: 3px;			
			color: #333333;
		}
		.blue {
			color: #225599;
		}
	}
  }
  .cars-zone {
      display: flex;
      padding: 10px 0;
	  justify-content: space-between;
      .cars-left {
		  a {
			img {
				width: 80px;
				height: 60px;
			}
		  }
      }
      .cars-right {
          width: 217px;
          p {
              line-height: 19px;
          }
          .p1 {
              a {
                color: #225599;
                font-weight: bold;
              }
          }
          .p2 {
              a {
                color: #cc0000;
                font-weight: bold;
              }
          }
		  .p3 {
			  a {
				color: #747474;
				margin-right: 20px;				  
			  }
		  }
      }
  }
	  .jjxx {
		.jjxxTit {
			height: 22px;
			line-height: 14px;
			color: #333333;
			border-bottom: 1px solid #e4e4e4;
			font-weight: bold;
		}
		.jjxxli {
			height: 31px;
			line-height: 31px;
			overflow: hidden;
			display: flex;
			a {
				color: #225599;
				display: block;
				width: 180px;
				float: left;
				overflow: hidden;
			}
			.del {
				color: #777777;
				text-decoration: line-through;
				display: block;
				width: 65px;
				text-align: right;
			}
			.red {
				font-weight: bold;
				display: block;
				text-align: right;
				width: 65px;
				a {
					width: 100%;
					color: #cc0000;					
				}			
			}
		}
	  }
}
</style>
